/* eslint-disable react/prop-types */
/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/accessible-emoji */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */

import { useQuery } from "@apollo/client";
import PropTypes from "prop-types";
import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { ME_HEADER_QUERY } from "../../graphql/user";
import endpoints from "../../shared/constants/endpoints";
import { orderMethods, orderTypeIds } from "../../shared/constants/order";
import Link from "../LinkWithCountry/LinkWithCountry";
import HeaderSignInRewardsLink from "./HeaderSignInRewardsLink";

import { doughProCategory } from "../../shared/repos/graphql/doughPro";
import {
  checkoutNoDeliveryAddressSelected,
  checkoutWithNoItems,
  getAddedCartLines,
  getCartLineQuantity
} from "../../shared/utilities/orders";

import * as elementsActions from "../../redux/actions/elements";
import * as userActions from "../../redux/actions/user";

import ProductsCategoryFilter from "../ProductsCategoryFilter/ProductsCategoryFilter";

import { modalBox } from "../../shared/constants/refs";
import {
  hasPermission,
  isMobile,
  routeCountryPath
} from "../../shared/utilities/common";
import {
  confirmToMenuPage,
  goBackToMain,
  menuStoreChange
} from "../../shared/utilities/store";

import { storeIds } from "../../shared/constants/store";
import RibbonBanner from "../RibbonBanner/RibbonBanner";
import styles from "./Header.module.css";

import { store } from "../../redux/store";
import { loadPunchhLoyalty } from "../../shared/utilities/loadPunchhLoyalty";
import cmsKeys from "../../shared/constants/cms";
import { METADATA_INFO } from "../../shared/constants/common";

import { LABELS } from "../../shared/constants/labels";
import { EZDINE, PUNCHH } from "../../shared/constants/loyaltyType";
import permissionTypes from "../../shared/constants/permissionTypes";

import * as storeRepo from "../../shared/repos/graphql/store";
import orderDispatches from "../../shared/utilities/order-dispatches";
import BarcodeWidget from "../BarcodeWidget/BarcodeWidget";
import CmsEditSwitch from "../Cms/CmsEditSwitch/CmsEditSwitch";

import siteSetting from "../../shared/constants/siteSetting";
import * as cms from "../../shared/repos/cms/cms";
import { handleCreateCart } from "../../shared/utilities/cart";
import DeliveryPickUpWidget from "../DeliveryPickUpWidget/DeliveryPickUpWidget";
import ThemeSwitch from "../ThemeSwitch/ThemeSwitch";
// eslint-disable-next-line import/no-cycle
import CartDropdown from "../Cart/CartDropdown";
import CookieToast from "./CookieToast";
import amplitudeAnalytics, { AMPLITUDE_NAV_SECTION } from "../../shared/utilities/amplitude";

const images = [];
images["app-logo"] = require("./imgs/app-logo.png");
images.logo = require("./imgs/logo.png");
images.logo2x = require("./imgs/logo@2x.png");
images["app-icon-light"] = require("./imgs/cart-icon-light.png");
images["cart-icon"] = require("./imgs/cart-icon.png");
images["cart-icon-light"] = require("./imgs/cart-icon-light.png");
images["dropdown-icon-light"] = require("./imgs/dropdown-icon-light.png");
images["dropdown-icon"] = require("./imgs/dropdown-icon.png");
images["nav-icon-light"] = require("./imgs/nav-icon-light.png");
images["nav-icon"] = require("./imgs/nav-icon.svg");
images["user-icon-light"] = require("./imgs/user-icon-light.png");
images["user-icon"] = require("./imgs/user-icon.svg");
const DeliveryIcon = require("./imgs/delivery.svg");
images["login-icon"] = require("./imgs/login.svg");
const PickupIcon = require("./imgs/pickup.png");
const locationIcon = require("./imgs/map-pin.svg");
const giftIcon = require("./imgs/gift.svg");

class Header extends Component {
  scrollUpValue = 0;

  constructor(props) {
    super(props);
    this.state = {
      content: [],
      renderNotification: false,
      showNotification: false,
      amountAdded: null,
      productAddedImagePath: null,
      openDeliveryWidget: false,
      showDeliveryWidget: false,
      deliveryPickupButton: "delivery",
      isScrollDirectionIsUp: false
    };
    this.headerElement = React.createRef();
  }

  async componentDidMount() {
    const {
      userAddress,
      location,
      toggleHeaderWidget,
      selectedStore,
      userOrderMethod,
      hasError,
      setDoughProSpecialCategory,
      userToken,
      activeLoyalty,
      order
    } = this.props;
    if (!userAddress) {
      if (location.pathname === "/home/address") {
        this.setState({
          showDeliveryWidget: true
        });
      }
    }

    if (
      location.pathname.includes("/products") &&
      !userAddress &&
      userOrderMethod !== orderMethods.shipping
    ) {
      toggleHeaderWidget();
    }

    if (!hasError) {
      doughProCategory()
        .then(res => {
          if (res && !res.loading && res.data) {
            setDoughProSpecialCategory(res.data.doughProSpecialCategory);
          }
        })
        .catch(() => {});
    }

    this.initializeRouteChangeListener();
    this.checkStickiness();
    this.checkDeliveryPickupStickness();
    this.handleStickySetting();

    if (userToken && activeLoyalty === PUNCHH) {
      await loadPunchhLoyalty(order);
    }

    window.addEventListener("click", this.handleOutsideClick);
    cms.getContent([cmsKeys.placeholders.enterDeliveryAddress], this);
    if (userAddress && !selectedStore) {
      this.setStateDispatchers();
    }
    this.fetchStoreCloseTimer();
    this.intervalId = setInterval(this.fetchStoreCloseTimer, 60000);
  }

  componentDidUpdate(prevProps) {
    const { location, userToken, activeLoyalty, order } = this.props;
    const { pathname } = location;
    if (pathname !== prevProps.location.pathname) {
      this.checkStickiness();
    }
    this.handleStickySetting();
    this.handleCartAmountUpdate(prevProps);

    const punchhReady = userToken && activeLoyalty === PUNCHH;
    const wasPunchhReady =
      prevProps.userToken && prevProps.activeLoyalty === PUNCHH;
    if (
      punchhReady &&
      (!wasPunchhReady ||
        prevProps.userToken !== userToken ||
        prevProps.activeLoyalty !== activeLoyalty)
    ) {
      loadPunchhLoyalty(order);
    }
  }

  componentWillUnmount() {
    const { setStickyCategories } = this.props;
    window.removeEventListener("scroll", this.handleStickySetting); // eslint-disable-line
    setStickyCategories(false);
    this.unlisten();
    clearInterval(this.intervalId);
  }

  fetchStoreCloseTimer = async () => {
    const { userCartId } = this.props;
    if (userCartId) {
      const response = await storeRepo.getStoreCloseTimer(userCartId);
      if (response?.data) {
        store.dispatch(elementsActions.setCloseTimer(response.data));
      }
    }
  };

  initializeRouteChangeListener = () => {
    const { history } = this.props;
    this.unlisten = history.listen(() => {
      this.checkStickiness();
    });
  };

  getLocationString = () => {
    const { userOrderMethod, selectedStore, userAddress } = this.props;

    let locationString = "";
    if (userOrderMethod === orderMethods.pickup) {
      locationString = selectedStore?.name || "";
    } else if (
      userAddress.address1 &&
      userAddress?.savedLocation?.locationLabel?.label
    ) {
      locationString = userAddress.savedLocation.locationLabel.label;
    } else if (userAddress.address1) {
      locationString = userAddress.address1;
    } else {
      locationString = selectedStore?.name || "";
    }

    return locationString;
  };

  setStateDispatchers = () => {
    const {
      setModalObject,
      setUserAddress,
      setSelectedStore,
      setUserOrderMethod
    } = this.props;
    setSelectedStore(null);
    setUserAddress(null);
    setUserOrderMethod("");
    setModalObject(null);
  };

  handleCartAmountUpdate = prevProps => {
    const { userCart } = this.props;
    const { userOrderMethod } = prevProps;
    const oldCartAmount = getCartLineQuantity(prevProps.userCart);
    const newCartAmount = getCartLineQuantity(userCart);

    if (userOrderMethod && oldCartAmount < newCartAmount) {
      const newAddedProduct = getAddedCartLines(userCart, prevProps.userCart);

      const newAddedProductImage =
        newAddedProduct.length > 0
          ? newAddedProduct[0].product?.productImageSmall
          : null;

      this.setState({
        renderNotification: true,
        amountAdded: newCartAmount - oldCartAmount,
        productAddedImagePath: newAddedProductImage
      });
      setTimeout(() => this.setState({ showNotification: true }), 100);
      setTimeout(() => this.setState({ showNotification: false }), 4000);
      setTimeout(() => this.setState({ renderNotification: false }), 4500);
    }
  };

  handleStickySetting = () => {
    const { setStickyCategories, categoriesPosition } = this.props;

    if (this.isStickyCategoriesEnabled())
      return setStickyCategories(
        window.pageYOffset >= (categoriesPosition || 0) - 100
      ); // eslint-disable-line

    return null;
  };

  returnIconTheme = (theme, icon, className = null) => {
    return (
      <img
        alt={`${theme}-${icon}`}
        src={images[`${icon}${theme === "light" ? "-light" : ""}`]}
        className={className}
      />
    );
  };

  toggleWidget = () => {
    const { toggleHeaderWidget } = this.props;
    toggleHeaderWidget();
  };

  toggleAddress = () => {
    this.setState({
      openDeliveryWidget: true
    });
    this.toggleWidget();
  };

  isStickyCategoriesEnabled = () => {
    const { location } = this.props;

    return (
      location.pathname === "/" ||
      location.pathname.includes("/menu") ||
      location.pathname === "/shipping" ||
      new RegExp(`^[/][a-z]{2}\\/?$`).test(location.pathname) ||
      new RegExp(`^[/][a-z]{2}\\/shipping$`).test(location.pathname)
    );
  };

  handleMenuClick = e => {
    e.preventDefault();
    const { location, history, selectedStore } = this.props;
    const menuLink = endpoints.getMenuUrl(selectedStore);

    const isStoreMenuPage = location.pathname.includes(endpoints.menu);
    const isShipingMenuPage = location.pathname.includes(
      endpoints.shippingPage
    );

    const isGiftStore = selectedStore && selectedStore.id === storeIds.giftCard;
    if (isStoreMenuPage || isGiftStore) {
      menuStoreChange(history.push, routeCountryPath(endpoints.homePage));
    }

    if (isShipingMenuPage) {
      this.handleStoreMenu(e);
      return;
    }

    if (selectedStore) {
      const isShippingMenu = selectedStore.id === storeIds.shipping;
      const menuPath = isShippingMenu ? `${endpoints.shippingPage}` : menuLink;
      history.push(routeCountryPath(menuPath));
    } else {
      history.push(routeCountryPath(menuLink));
    }
  };

  confirmViewMenu = e => {
    e.preventDefault();
    const { history, selectedStore, userAddress } = this.props;
    const menuLink = endpoints.getMenuUrl(selectedStore);
    const address = userAddress.address1
      ? [userAddress.address1, userAddress.city, userAddress.state].join(", ")
      : selectedStore?.name;
    confirmToMenuPage(
      history.push,
      this.handleDeliveryWidget,
      address,
      routeCountryPath(menuLink)
    );
  };

  handleStoreMenu = async e => {
    e.preventDefault();
    const {
      history,
      selectedStore,
      userAddress,
      location,
      userCart,
      userCartId,
      userOrderMethod,
      setUserCartId,
      setUserAddress
    } = this.props;

    const isShipingMenuPage = location.pathname.includes(
      endpoints.shippingPage
    );
    if (isShipingMenuPage || userOrderMethod === orderMethods.shipping) {
      if (userCart.length > 0) {
        goBackToMain(history.push, routeCountryPath(endpoints.homePage));
      } else {
        orderDispatches(store, userActions, elementsActions);
        history.push(routeCountryPath(endpoints.homePage));
      }
      return;
    }

    if (userAddress || selectedStore) {
      const menuLink = endpoints.getMenuUrl(selectedStore);
      const isShippingMenu = selectedStore?.id === storeIds.shipping;
      const menuPath = isShippingMenu ? `${endpoints.shippingPage}` : menuLink;
      if (!userCartId || userCartId.length === 0) {
        await handleCreateCart(
          selectedStore,
          userAddress,
          userOrderMethod,
          setUserCartId,
          setUserAddress
        );
      }
      history.push(routeCountryPath(menuPath));
    } else {
      this.toggleAddress();
    }
  };

  handleOutsideClick = event => {
    const { showHeaderWidget, toggleHeaderWidget } = this.props;
    const { openDeliveryWidget } = this.state;
    const canToggleWidget =
      showHeaderWidget &&
      !openDeliveryWidget &&
      modalBox &&
      !modalBox?.current?.contains(event.target) &&
      !document
        .getElementsByClassName(styles.deliveryContainer)[0]
        ?.contains(event.target);
    if (canToggleWidget) {
      toggleHeaderWidget();
    }
    this.setState({
      openDeliveryWidget: false
    });
  };

  handleCartIconLink = async e => {
    e.preventDefault();
    const {
      userCart,
      userAddress,
      userOrderMethod,
      toggleCartMenu
    } = this.props;
    if (
      !userAddress &&
      userCart.length <= 0 &&
      userOrderMethod !== orderMethods.shipping
    ) {
      checkoutNoDeliveryAddressSelected(this.toggleAddress);
      return;
    }

    if (userCart.length <= 0) {
      checkoutWithNoItems();
      return;
    }
    toggleCartMenu();
  };

  renderCartDropDown = shouldNotDisplayIntroBanner => {
    return (
      <CartDropdown shouldNotDisplayIntroBanner={shouldNotDisplayIntroBanner} />
    );
  };

  handleDeliveryWidget = value => {
    this.setState({
      showDeliveryWidget: value
    });
  };

  handleDeliveryPickupButton = value => {
    this.setState(
      {
        deliveryPickupButton: value
      },
      () => {
        // Move focus to the address input field after selection to indicate content update
        const addressInput = document.getElementById("delivery-address-input");
        if (addressInput) {
          addressInput.focus();
        }
      }
    );
  };

  userAuthenticationButton = (
    history,
    loggedIn,
    theme,
    data,
    userFirstname,
    userLastname,
    signInButtonStyleChange,
    signInButtonText,
    existUserFullName,
    isMenu = true
  ) => {
    const { activeLoyalty } = this.props;
    return (
      <div
        className={`${styles.userContainer}  ${
          loggedIn ? styles.userContainerLoggedIn : null
        }`}
      >
        {loggedIn ? (
          <Link to="/user/profile" aria-label="User Profile">
            <div
              className={[
                styles.userDetails,
                "gap-2 -mr-2 px-4 py-1 hidden md:flex",
                `${!isMenu ? "border-white text-white" : ""}`
              ].join(" ")}
            >
              <img alt={`${theme}-user-icon`} src={images["user-icon"]} />

              <div className="flex items-center justify-center">
                <div>{`${userFirstname} ${userLastname}`}</div>
                {activeLoyalty === EZDINE ? (
                  <>
                    <span className="bg-white h-1 w-1 rounded-full mx-1" />
                    <h3>{`${data.me.loyalty.points}pts`}</h3>
                  </>
                ) : null}
              </div>
            </div>
          </Link>
        ) : (
          <HeaderSignInRewardsLink
            to="/login"
            signInButtonStyleChange={signInButtonStyleChange}
            signInButtonText={signInButtonText}
            moduleStyles={styles}
          />
        )}
        {loggedIn ? (
          <Link to="/user/profile" aria-label="User Profile">
            <div className={styles.mobileDetailsWrapper}>
              <div
                className={[
                  styles.userDetailsMobile,
                  !existUserFullName ? styles.noBorder : null
                ].join(" ")}
              >
                {existUserFullName ? (
                  <p>{`${userFirstname[0]}  ${userLastname[0]}`}</p>
                ) : (
                  this.returnIconTheme(theme, "user-icon")
                )}
              </div>
              {activeLoyalty === EZDINE && (
                <span>{`${data.me.loyalty.points}pts`}</span>
              )}
            </div>
          </Link>
        ) : null}
      </div>
    );
  };

  userCartLink = (
    cartIconLink,
    cartQuantity,
    userCart,
    renderNotification,
    showNotification,
    amountAdded,
    isMenu = true
  ) => {
    const { productAddedImagePath } = this.state;
    const hasCartItems = userCart.length > 0;
    return (
      <Link
        tabIndex={0}
        onKeyDown={e => e.key === "Enter" && this.handleCartIconLink(e)}
        to={cartIconLink}
        onClick={this.handleCartIconLink}
      >
        <div
          id="cart-container"
          className={`${
            styles.cartContainer
          } h-[50px] w-[50px] flex items-center ${
            !isMenu ? "bg-dark rounded-full" : ""
          } hidden md:block`}
        >
          <img
            id="cart-icon"
            data-ddog-id="cart_icon"
            src={images["cart-icon"]}
            alt=""
            className="h-[50px] w-[50px] object-cover"
          />
          <span
            id="cart_quantity"
            data-ddog-id="cart_quantity"
            className={`${styles.cartQuantity} absolute ${
              !isMenu ? "right-[33%]" : "right-[20%]"
            } top-[28%] w-4 text-center`}
          >
            {cartQuantity}
          </span>
          {!hasCartItems ? (
            <div
              className={`
                      ${styles.cartAlertContainer}
                      py- bg-light text-dark
                      zIndex
                      `}
            >
              <p className="py-2 ">No items in your cart</p>
            </div>
          ) : null}
          <div
            role="status"
            aria-live="polite"
            aria-atomic="true"
            className={[
              renderNotification ? styles.renderNotification : null,
              showNotification ? styles.showNotification : null,
              styles.cartNotificationContainer,
              "zIndex text-white"
            ].join(" ")}
          >
            <div className="fixed z-[999999]">
              <CookieToast
                count={amountAdded}
                imageUrl={productAddedImagePath}
                isMenu={isMenu}
              />
            </div>
          </div>
        </div>
      </Link>
    );
  };

  userRewardLink = (isMenu, theme) => {
    const { newRedeemableLvlUnlocked, newOfferAvailable } = this.props;

    const showIndicator = newRedeemableLvlUnlocked || newOfferAvailable;

    return (
      <div className={`${styles.userContainer}`}>
        <Link to="/user/loyalty-rewards" aria-label="Loyalty Rewards">
          <div
            className={[
              styles.loyaltyReward,
              "gap-2 px-4 py-1 flex",
              `${!isMenu ? "border-white text-white" : ""}`
            ].join(" ")}
          >
            <img
              alt={`${theme}-user-icon`}
              className="hidden md:block"
              src={giftIcon}
            />

            <div className="flex items-center justify-center">
              <div>{LABELS.REWARDS}</div>
              {showIndicator && (
                <span className="w-4 h-4 border-2 rounded-full border-dark bg-button -mr-5 -mt-6" />
              )}
            </div>
          </div>
        </Link>
      </div>
    );
  };

  header = () => {
    const {
      userCart,
      theme,
      hasActiveOrders,
      noActiveOrders,
      toggleMobileMenu,
      showHeaderWidget,
      showMobileMenu,
      isStickyCategories,
      isBetaCustomer,
      userToken,
      userOrderMethod,
      userAddress,
      setUserId,
      setUserAddress,
      setBetaCustomer,
      setPermissions,
      setSelectedStore,
      history,
      location,
      setDoughProMember,
      isDoughProActive,
      userInfo,
      userCartId,
      shouldDisplayIntroBanner,
      pathname,
      headRef,
      showDeliveryPickupWidget,
      hideHeaderMenuOnScroll,
      themeSettings,
      activeLoyalty,
      closeTimer,
      cartTransactionId,
      pendingTotal,
      setUserOrderMethod,
      selectedStore,
      enableDefaultAddressForGuestUsers,
      guestUserAddress,
      guestUserOrderMethod,
      guestSelectedStore,
      hasEventStarted,
      eventApplicationLogoWebsite,
      eventApplicationLogoMobile,
      showDeliveryPickupAddressBar
    } = this.props;

    const {
      amountAdded,
      showNotification,
      renderNotification,
      content,
      showDeliveryWidget,
      deliveryPickupButton,
      isScrollDirectionIsUp
    } = this.state;

    let headerQueryResponse = {};
    if (userToken) {
      headerQueryResponse = useQuery(ME_HEADER_QUERY, {
        fetchPolicy: "no-cache",
        variables: { language: "english" },
        onCompleted: async res => {
          setUserId(res.me.id);
          if (
            res.me.lastCompletedOrder?.orderTypeId === orderTypeIds.pickup &&
            !selectedStore?.id
          ) {
            const storeObj = res.me.lastCompletedOrder.store;
            setSelectedStore(storeObj);
            setUserOrderMethod(orderMethods.pickup);
            const addressComponents = {
              address1: storeObj.mailingAddress,
              city: storeObj.city,
              state: storeObj.state,
              postcode: storeObj.zip,
              lat: storeObj.lat,
              lng: storeObj.lng,
              countryId: parseInt(storeObj.countryId, 10)
            };
            setUserAddress(addressComponents);
          } else {
            const savedLocation = res.me.savedLocations.locations[0] ?? null;
            if (savedLocation && !userAddress?.address1) {
              const { addressDetails } = savedLocation;
              const data = {
                lat: addressDetails.lat,
                lng: addressDetails.lng,
                externalId: savedLocation.sourceId,
                orderTypeId: orderTypeIds.delivery
              };
              const result = await storeRepo.getStores(data);
              const { stores } = result.data.storeSearch;
              const storeInDeliveryRangeIndex = stores.findIndex(
                el => el.inDeliveryRange === true
              );
              setUserAddress({ ...addressDetails, savedLocation });
              setSelectedStore(stores[storeInDeliveryRangeIndex]);
              setUserOrderMethod(orderMethods.delivery);
            }
          }
        }
      });
    } else if (
      !selectedStore?.id &&
      enableDefaultAddressForGuestUsers &&
      guestSelectedStore
    ) {
      setSelectedStore(guestSelectedStore);
      setUserOrderMethod(guestUserOrderMethod);
      setUserAddress(guestUserAddress);
    }

    const { data, loading } = headerQueryResponse || {
      data: null,
      loading: false
    };

    let loggedIn = false;
    let canEditCms = false;
    if (!loading) {
      loggedIn =
        userToken !== null && userToken !== undefined && data && data.me;
      setBetaCustomer(loggedIn && data.me && data.me.isBetaCustomer);
      setPermissions(data?.me?.permissions || []);
      canEditCms =
        loggedIn &&
        data.me &&
        hasPermission(
          data.me.permissions,
          permissionTypes.cms.category,
          permissionTypes.cms.permissions.edit_values
        );
    }

    const firstname = data?.me?.firstname || "";
    const lastname = data?.me?.lastname || "";
    const userFirstname = userInfo?.user?.firstName || firstname;
    const userLastname = userInfo?.user?.lastName || lastname;
    const existUserFullName = !!(userFirstname && userLastname);

    if (loggedIn && data.me.isBetaCustomer) {
      setDoughProMember(data.doughProMember);
    }

    const cartQuantity =
      getCartLineQuantity(userCart) + (pendingTotal || 0);

    const showStickyCategories =
      isStickyCategories && !(isMobile() && showHeaderWidget);

    const cartIconLink =
      userCart.length > 0
        ? endpoints.checkoutOrderPage.replace(":id", userCartId)
        : endpoints.checkoutViewOrderPage;

    const ribbonBanner = !shouldDisplayIntroBanner ? (
      <div className={`${styles.ribbonBannerWrapper}`}>
        <RibbonBanner />
      </div>
    ) : null;

    const signInButtonText = LABELS.SIGN_IN;
    let signInButtonStyleChange = false;
    if (window.innerWidth < 430) {
      signInButtonStyleChange = true;
    }

    const disableCssClass =
      " opacity-60 bg-opacity-60 border-opacity-60 text-opacity-60";
    const hoverCssClass =
      " hover:opacity-100 hover:bg-opacity-100 hover:border-opacity-100 hover:text-opacity-100";
    const userLoggedIn = userToken && (isBetaCustomer || isDoughProActive);
    const userHasActiveOrders =
      userLoggedIn && data?.me?.activeOrders?.totalCount > 0;

    const handleMobileNavClick = async () => {
      if (!showMobileMenu) {
        amplitudeAnalytics.trackOpenHamburgerMenu({
          pathname: location.pathname,
        });
      }

      toggleMobileMenu();

      if (userHasActiveOrders) {
        await hasActiveOrders();
      } else {
        await noActiveOrders();
      }
    };

    return (
      <div className={`${styles.headerWrapper} border-mainDark`} ref={headRef}>
        {ribbonBanner}

        {
          <div
            className={`${styles.headerContainer} ${
              !hideHeaderMenuOnScroll ? "lg:hidden" : ""
            }
            ${!hideHeaderMenuOnScroll && loggedIn ? "hidden lg:block" : ""}
            ${
              theme === "light" ? styles.isLight : styles.isDark
            } min-h-20 md:min-h-[68px] w-full bg-dark border-b border-[#5A3770] py-3`}
          >
            <div className="max-w-screen-desktop mx-auto w-full">
              <div className="flex flex-row items-center justify-between md:px-0 px-3 w-full min-w-0">
                <div
                  className={`${styles.headerLeft} flex gap-2 flex-shrink-0`}
                >
                  <Link
                    aria-label="insomnia cookies homepage"
                    onKeyDown={e =>
                      e.key === "Enter" && this.handleMenuClick(e)}
                    onClick={this.handleMenuClick}
                    to={location.pathname}
                    name="home_page_link"
                    className="w-[60px] md:w-full"
                  >
                    <img
                      src={
                        hasEventStarted
                          ? eventApplicationLogoMobile
                          : images["app-logo"]
                      }
                      alt=""
                      className="block md:hidden h-[60px] w-[60px] object-cover"
                    />
                    <img
                      src={
                        hasEventStarted
                          ? eventApplicationLogoWebsite
                          : images.logo
                      }
                      srcSet={
                        hasEventStarted
                          ? undefined
                          : `${images.logo} 1x, ${images.logo2x} 2x`
                      }
                      alt="insomnia cookies logo"
                      className="hidden md:block h-10 object-cover "
                    />
                  </Link>
                  {showHeaderWidget && showDeliveryPickupAddressBar ? (
                    <div className={styles.widgetWrapper} ref={modalBox}>
                      <DeliveryPickUpWidget
                        cmsContent={content}
                        addressType={deliveryPickupButton}
                        analyticsPageSection="Nav"
                      />
                    </div>
                  ) : null}
                </div>

                <div
                  className={`${styles.headerRight} ${
                    theme === "light" ? styles.isLight : styles.isDark
                  } flex items-center md:gap-5 ${
                    userLoggedIn ? "gap-3" : "gap-0"
                  } text-white font-montserratMedium flex-shrink min-w-0`}
                >
                  <div className="flex flex-col gap-2">
                    {canEditCms && <CmsEditSwitch showOnMobileView={false} />}
                    {themeSettings[siteSetting.IS_THEME_SWITCH_ENABLED] && (
                      <ThemeSwitch />
                    )}
                  </div>
                  <p className="whitespace-nowrap flex-shrink-0">
                    <Link
                      to={endpoints.menu}
                      onClick={e => {
                        amplitudeAnalytics.trackClickNavPrimary({
                          navElement: "Menu",
                          navSection: AMPLITUDE_NAV_SECTION.TOP_NAV,
                          pathname: location.pathname,
                        });
                        this.handleStoreMenu(e);
                      }}
                      onKeyDown={e => {
                        if (e.key === "Enter" || e.key === " ") {
                          e.preventDefault();
                          this.handleStoreMenu(e);
                        }
                      }}
                      name="menu_link"
                    >
                      Menu
                    </Link>
                  </p>

                  {userLoggedIn && (
                    <p className="whitespace-nowrap flex-shrink-0">
                      <Link
                        id="ordersPageLink"
                        to={endpoints.orders}
                        className={`${styles.ordersLink}`}
                        onClick={() => {
                          amplitudeAnalytics.trackClickNavPrimary({
                            navElement: "Orders",
                            navSection: AMPLITUDE_NAV_SECTION.TOP_NAV,
                            pathname: location.pathname,
                          });
                        }}
                      >
                        {LABELS.ORDERS}

                        {userHasActiveOrders && (
                          <span
                            className={`${styles.ordersAttentionGrabber}`}
                          />
                        )}
                      </Link>
                    </p>
                  )}

                  <p className="whitespace-nowrap flex-shrink-0">
                    <Link
                      to={endpoints.locations}
                      onClick={() => {
                        amplitudeAnalytics.trackClickNavPrimary({
                          navElement: "Locations",
                          navSection: AMPLITUDE_NAV_SECTION.TOP_NAV,
                          pathname: location.pathname,
                        });
                      }}
                    >
                      {METADATA_INFO.HEADER_LINK.LOCATION}
                    </Link>
                  </p>

                  <p className="whitespace-nowrap flex-shrink-0">
                    <Link
                      to={endpoints.gifting}
                      onClick={() => {
                        amplitudeAnalytics.trackClickNavPrimary({
                          navElement: "Gifting",
                          navSection: AMPLITUDE_NAV_SECTION.TOP_NAV,
                          pathname: location.pathname,
                        });
                      }}
                    >
                      {LABELS.GIFTING}
                    </Link>
                  </p>

                  <p className="whitespace-nowrap flex-shrink-0">
                    <Link
                      id="shippingPageLink"
                      to={endpoints.shippingPage}
                      className={`${styles.ordersLink}`}
                      onClick={() => {
                        amplitudeAnalytics.trackClickNavPrimary({
                          navElement: "Shipping",
                          navSection: AMPLITUDE_NAV_SECTION.TOP_NAV,
                          pathname: location.pathname,
                        });
                      }}
                    >
                      {LABELS.SHIPPING}
                    </Link>
                  </p>

                  {!userLoggedIn && (
                    <p className="whitespace-nowrap flex-shrink-0">
                      <Link
                        to={endpoints.rewardLandingPage}
                        onClick={() => {
                          amplitudeAnalytics.trackClickNavPrimary({
                            navElement: "Join Rewards",
                            navSection: AMPLITUDE_NAV_SECTION.TOP_NAV,
                            pathname: location.pathname,
                          });
                        }}
                      >
                        {LABELS.GUEST_REWARDS}
                      </Link>
                    </p>
                  )}

                  {loggedIn &&
                    activeLoyalty === "punchh" &&
                    this.userRewardLink(false, theme)}
                  {/* Sign In button */}
                  {this.userAuthenticationButton(
                    history,
                    loggedIn,
                    theme,
                    data,
                    userFirstname,
                    userLastname,
                    signInButtonStyleChange,
                    signInButtonText,
                    existUserFullName
                  )}
                  {/* Cart Link */}
                  {this.userCartLink(
                    cartIconLink,
                    cartQuantity,
                    userCart,
                    renderNotification,
                    showNotification,
                    amountAdded,
                    true,
                    cartTransactionId
                  )}
                  <div
                    onClick={handleMobileNavClick}
                    className={styles.navContainer}
                  >
                    {this.returnIconTheme(theme, "nav-icon")}

                    {userHasActiveOrders && (
                      <span className={`${styles.ordersAttentionGrabber}`} />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        }
        {showDeliveryPickupAddressBar &&
          (userAddress ||
            showDeliveryPickupWidget ||
            pathname !== "/" ||
            isMobile()) &&
          pathname &&
          !pathname.match(/login/g) &&
          !pathname.match(/gifting/g) &&
          !pathname.match(/contact/g) &&
          !pathname.match(/create-account/g) &&
          !pathname.match(/checkout\/review-order/g) &&
          pathname !== endpoints.locations &&
          pathname !== endpoints.doughProPage &&
          !pathname.match(endpoints.orderLoyaltyRegex) && (
            <div className="bg-dark border-mainDark shadow-md ">
              <div className="flex md:max-w-screen-desktop md:px-0 px-4 m-auto py-[6px] min-w-0 overflow-x-auto">
                {userAddress && userOrderMethod !== orderMethods.shipping ? (
                  <div className="flex gap-2 items-center flex-1 md:h-12 min-w-0">
                    {userOrderMethod === orderMethods.pickup ? (
                      <img
                        src={PickupIcon}
                        alt=""
                        className="md:block hidden"
                      />
                    ) : (
                      <img
                        src={DeliveryIcon}
                        alt=""
                        className="md:block hidden"
                      />
                    )}
                    <div className="text-white font-montserratMedium min-w-0">
                      <div className="md:flex items-center gap-3 flex-wrap">
                        <p className="md:py-2 whitespace-nowrap">
                          {userOrderMethod !== orderMethods.pickup
                            ? "Warm Cookie Delivery"
                            : "Delicious Cookie Pickup"}
                        </p>
                        <p className="font-bold flex gap-2 items-center flex-wrap min-w-0">
                          <span className="break-words min-w-0">
                            {this.getLocationString()}
                          </span>

                          {pathname !== "/" && !pathname.match(/profile/g) ? (
                            // eslint-disable-next-line
                            <a
                              id="handleDeliveryWidget"
                              onClick={() => this.handleDeliveryWidget(true)}
                              role="button"
                              tabIndex={0}
                              aria-hidden
                              onKeyDown={e =>
                                e.key === "Enter" &&
                                this.handleDeliveryWidget(true)}
                              className="text-dryPink underline cursor-pointer"
                            >
                              Change
                            </a>
                          ) : (
                            // eslint-disable-next-line
                            <a
                              onClick={this.confirmViewMenu}
                              role="button"
                              tabIndex={0}
                              onKeyDown={e =>
                                e.key === "Enter" && this.confirmViewMenu()}
                              className="text-dryPink underline cursor-pointer text-xs lg:text-[16px]"
                            >
                              View Menu
                            </a>
                          )}
                        </p>
                      </div>
                    </div>
                  </div>
                ) : userOrderMethod !== orderMethods.shipping ? (
                  (showDeliveryPickupWidget ||
                    pathname !== "/" ||
                    isMobile()) && (
                    <div
                      className={`md:flex gap-2 items-center md:h-12 ${
                        showDeliveryPickupWidget && isScrollDirectionIsUp
                          ? "h-12"
                          : "h-24"
                      } flex-1 mr-2`}
                    >
                      <div
                        className={`flex gap-2  ${
                          showDeliveryPickupWidget && isScrollDirectionIsUp
                            ? ""
                            : "md:mb-0 mb-2"
                        }`}
                      >
                        <button
                          type="button"
                          id="deliveryWidget"
                          onClick={() =>
                            this.handleDeliveryPickupButton("delivery")}
                          tabIndex={0}
                          onKeyDown={e =>
                            e.key === "Enter" &&
                            this.handleDeliveryPickupButton("delivery")}
                          aria-pressed={deliveryPickupButton === "delivery"}
                          aria-label="Delivery - Select delivery order method"
                          className={` ${
                            showDeliveryPickupWidget && isScrollDirectionIsUp
                              ? "hidden md:flex"
                              : "flex"
                          }
                      flex-row justify-center items-center
                    md:w-[183px] w-full px-4 py-1 gap-2 h-11 bg-transparent border
                    border-borderLight border-solid rounded-[54px] text-white
                    font-montserratBold ${
                      deliveryPickupButton === "delivery"
                        ? "opactity-100"
                        : disableCssClass
                    }
                    ${hoverCssClass}
                    `}
                        >
                          <img src={DeliveryIcon} alt="" aria-hidden="true" />
                          Delivery
                        </button>
                        <button
                          type="button"
                          id="pickupWidget"
                          onClick={() =>
                            this.handleDeliveryPickupButton("pickup")}
                          tabIndex={0}
                          onKeyDown={e =>
                            e.key === "Enter" &&
                            this.handleDeliveryPickupButton("pickup")}
                          aria-pressed={deliveryPickupButton === "pickup"}
                          aria-label="Pickup - Select pickup order method"
                          className={` ${
                            showDeliveryPickupWidget && isScrollDirectionIsUp
                              ? "hidden md:flex"
                              : "flex"
                          }
                    flex flex-row justify-center items-center
                    md:w-[183px] w-full px-4 py-1 gap-2 h-11 bg-transparent border
                    border-borderLight border-solid rounded-[54px]
                    text-white font-montserratBold
                    ${
                      deliveryPickupButton === "pickup"
                        ? "opactity-100 bg-[none]"
                        : disableCssClass
                    }
                    ${hoverCssClass}
                    `}
                        >
                          <img src={PickupIcon} alt="" aria-hidden="true" />
                          Pickup
                        </button>
                      </div>
                      <div
                        id="delivery-address-input"
                        className="flex flex-row items-center gap-3 h-11 border
                border-mainDark rounded-[54px] py-3 px-4 w-full lg:w-[400px] max-w-full text-white
                leading-5 bg-gradient-l bg-gradient-to-l from-darkBlack
                  to-darkBlack cursor-pointer min-w-0"
                        onClick={() => this.handleDeliveryWidget(true)}
                        role="button"
                        tabIndex={0}
                        onKeyDown={e =>
                          e.key === "Enter" && this.handleDeliveryWidget(true)}
                        aria-label={`Enter ${deliveryPickupButton} address`}
                      >
                        <img
                          className="w-5 h-5 flex-shrink-0"
                          alt=""
                          aria-hidden="true"
                          src={locationIcon}
                        />
                        <p className="whitespace-nowrap overflow-hidden text-ellipsis">{`Enter ${deliveryPickupButton} address`}</p>
                      </div>
                    </div>
                  )
                ) : (
                  <div className="md:flex gap-2 items-center flex-1 md:h-12 mr-2">
                    <p>
                      <button
                        type="button"
                        onClick={this.handleStoreMenu}
                        tabIndex={0}
                        onKeyDown={e =>
                          e.key === "Enter" && this.handleStoreMenu()}
                        className="rounded-40 py-2 px-4
                        border-[1px] border-solid border-darkDry text-white"
                      >
                        Return to Delivery and Pickup
                      </button>
                    </p>
                  </div>
                )}

                {!hideHeaderMenuOnScroll && !isMobile() && (
                  <div
                    className={`${styles.headerAddress} overflow-hidden flex flex-shrink-0 items-center gap-8 min-h-[50px]`}
                  >
                    {loggedIn &&
                      activeLoyalty === "punchh" &&
                      this.userRewardLink(false, theme)}
                    {/* Sign In button */}
                    {this.userAuthenticationButton(
                      history,
                      loggedIn,
                      theme,
                      data,
                      userFirstname,
                      userLastname,
                      signInButtonStyleChange,
                      signInButtonText,
                      existUserFullName,
                      false
                    )}
                    {/* Cart Link */}
                    {this.userCartLink(
                      cartIconLink,
                      cartQuantity,
                      userCart,
                      renderNotification,
                      showNotification,
                      amountAdded,
                      false,
                      cartTransactionId
                    )}
                  </div>
                )}
              </div>
            </div>
          )}
        {this.renderCartDropDown(shouldDisplayIntroBanner)}

        {showDeliveryWidget ? (
          <DeliveryPickUpWidget
            isVisible={showDeliveryWidget}
            onClose={() => this.handleDeliveryWidget(false)}
            addressType={deliveryPickupButton}
            cmsContent={content}
            analyticsPageSection="Nav"
          />
        ) : null}

        {showStickyCategories ? (
          <div
            className={`${styles.categoriesWrapper} ${
              pathname === "/"
                ? "hidden"
                : "w-full bg-dark rounded-none border-t-2 border-solid border-[#5A3770]"
            }`}
          >
            <div className="lg:max-w-screen-desktop px-4 lg:px-0 m-auto">
              <ProductsCategoryFilter mobileDarkTheme onChange={() => null} />
            </div>
          </div>
        ) : null}

        <BarcodeWidget />
        <div
          role="status"
          aria-live="polite"
          aria-atomic="true"
          className={
            closeTimer && closeTimer.timerShouldShow
              ? "flex md:px-0 px-4 m-auto"
              : "sr-only"
          }
          style={
            closeTimer && closeTimer.timerShouldShow
              ? { backgroundColor: "rgb(224, 23, 102)" }
              : {}
          }
        >
          <div className="flex md:max-w-screen-desktop md:px-0 px-4 m-auto py-1">
            {closeTimer && closeTimer.timerMessage ? (
              <p
                className="font-montserratBold mx-auto"
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML={{ __html: closeTimer.timerMessage }}
              />
            ) : null}
          </div>
        </div>
      </div>
    );
  };

  checkStickiness = () => {
    const { categoriesPosition, setStickyCategories } = this.props;

    if (this.isStickyCategoriesEnabled()) {
      setStickyCategories(window.pageYOffset >= categoriesPosition - 100); // eslint-disable-line

      window.addEventListener("scroll", this.handleStickySetting); // eslint-disable-line
    } else {
      window.removeEventListener("scroll", this.handleStickySetting); // eslint-disable-line
      setStickyCategories(false);
    }
  };

  handleScrollDeliveryPickupWidget = () => {
    const { setDeliveryPickupAddressWidget } = this.props;
    const { isScrollDirectionIsUp } = this.state;
    const isScroll = window.pageYOffset >= 250;
    const windowScroll = window.scrollY;
    let isScrollDirectionIsUpVal = false;
    if (this.scrollUpValuel < windowScroll && isMobile()) {
      isScrollDirectionIsUpVal = true;
    }
    this.scrollUpValuel = windowScroll;
    if (isScrollDirectionIsUpVal !== isScrollDirectionIsUp) {
      this.setState({
        isScrollDirectionIsUp: isScrollDirectionIsUpVal
      });
    }

    return setDeliveryPickupAddressWidget({
      showDeliveryPickupWidget: isScroll,
      hideHeaderMenuOnScroll: !isScroll
    });
  };

  checkDeliveryPickupStickness = () => {
    window.addEventListener("scroll", this.handleScrollDeliveryPickupWidget);
  };

  render() {
    return <this.header />;
  }
}

Header.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired
  }).isRequired,
  theme: PropTypes.string,
  hasActiveOrders: PropTypes.func.isRequired,
  noActiveOrders: PropTypes.func.isRequired,
  toggleMobileMenu: PropTypes.func.isRequired,
  showMobileMenu: PropTypes.bool,
  pathname: PropTypes.string,
  toggleHeaderWidget: PropTypes.func,
  showHeaderWidget: PropTypes.bool,
  isStickyCategories: PropTypes.bool,
  setStickyCategories: PropTypes.func,
  categoriesPosition: PropTypes.number,
  userToken: PropTypes.string,
  userOrderMethod: PropTypes.string,
  userAddress: PropTypes.shape({ address1: PropTypes.string }),
  selectedStore: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string
  }),
  userCart: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    })
  ),
  headRef: PropTypes.shape({}),
  themeSettings: PropTypes.shape({}),
  activeLoyalty: PropTypes.string,
  cartTransactionId: PropTypes.string,
  pendingTotal: PropTypes.number,
  toggleCartMenu: PropTypes.func,
  showDeliveryPickupAddressBar: PropTypes.bool
};

Header.defaultProps = {
  userCart: [],
  theme: "dark",
  pathname: null,
  showMobileMenu: false,
  toggleHeaderWidget: null,
  showHeaderWidget: null,
  isStickyCategories: false,
  setStickyCategories: null,
  categoriesPosition: null,
  userToken: null,
  userOrderMethod: null,
  userAddress: null,
  selectedStore: null,
  headRef: null,
  themeSettings: {},
  activeLoyalty: null,
  cartTransactionId: null,
  pendingTotal: 0,
  toggleCartMenu: () => null,
  showDeliveryPickupAddressBar: true
};

export const mapStateToProps = state => {
  const {
    showHeaderWidget,
    showMobileMenu,
    isStickyCategories,
    categoriesPosition,
    showDeliveryPickupWidget,
    hideHeaderMenuOnScroll,
    closeTimer
  } = state.elements;
  const {
    cartTransactionId,
    userToken,
    userAddress,
    selectedStore,
    userOrderMethod,
    userCart,
    endpoint,
    userInfo,
    userCartId,
    isBetaCustomer,
    userId
  } = state.user;
  const {
    guestUserAddress,
    guestUserOrderMethod,
    guestSelectedStore
  } = state.guestUser;
  const { isDoughProActive } = state.doughPro;
  const { isShippingActive } = state.shipping;
  const { shouldDisplayIntroBanner } = state.braze;
  const {
    footerMenuItemsSettings,
    footerMenuItemsLinksSettings
  } = state.footerSettings;
  const { order } = state;
  const { themeSettings } = state.theme;
  const {
    newRedeemableLvlUnlocked,
    activeLoyalty,
    newOfferAvailable
  } = state.loyalty;
  const { pendingTotal } = state.optimisticCart;
  const {
    eventEndDate,
    eventApplicationLogoWebsite,
    eventApplicationLogoMobile
  } = state.event;
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const endDate = new Date(eventEndDate);
  endDate.setHours(0, 0, 0, 0);
  const hasEventStarted = eventEndDate ? today <= endDate : false;

  return {
    showHeaderWidget,
    showMobileMenu,
    isStickyCategories,
    categoriesPosition,
    userAddress,
    selectedStore,
    userOrderMethod,
    userToken,
    userCart,
    userCartId,
    userInfo,
    endpoint,
    isBetaCustomer,
    isDoughProActive,
    isShippingActive,
    userId,
    shouldDisplayIntroBanner,
    footerMenuItemsSettings,
    footerMenuItemsLinksSettings,
    showDeliveryPickupWidget,
    hideHeaderMenuOnScroll,
    order,
    themeSettings,
    closeTimer,
    activeLoyalty,
    newRedeemableLvlUnlocked,
    newOfferAvailable,
    cartTransactionId,
    pendingTotal,
    guestUserAddress,
    guestUserOrderMethod,
    guestSelectedStore,
    enableDefaultAddressForGuestUsers:
      state.address.enableDefaultAddressForGuestUsers,
    eventEndDate,
    hasEventStarted,
    eventApplicationLogoWebsite,
    eventApplicationLogoMobile
  };
};

export const mapDispatchToProps = dispatch => ({
  hasActiveOrders: () => dispatch(elementsActions.hasActiveOrders()),
  noActiveOrders: () => dispatch(elementsActions.noActiveOrders()),
  toggleMobileMenu: () => dispatch(elementsActions.toggleMobileMenu()),
  toggleHeaderWidget: () => dispatch(elementsActions.toggleHeaderWidget()),
  setStickyCategories: value =>
    dispatch(elementsActions.setStickyCategories(value)),
  setDoughProSpecialCategory: value =>
    dispatch(elementsActions.setDoughProSpecialCategory(value)),
  setUserId: value => dispatch(userActions.setUserId(value)),
  setModalObject: value => dispatch(elementsActions.setModalObject(value)),
  setBetaCustomer: value => dispatch(userActions.setBetaCustomer(value)),
  setDoughProMember: value => dispatch(userActions.setDoughProMember(value)),
  setDeliveryPickupAddressWidget: value =>
    dispatch(elementsActions.setDeliveryPickupAddressWidget(value)),
  setUserOrderMethod: value => dispatch(userActions.setUserOrderMethod(value)),
  setUserAddress: value => dispatch(userActions.setUserAddress(value)),
  setSelectedStore: value => dispatch(userActions.setSelectedStore(value)),
  setCloseTimer: value => dispatch(elementsActions.setCloseTimer(value)),
  setPermissions: value => dispatch(userActions.setPermissions(value)),
  setUserCartId: value => dispatch(userActions.setUserCartId(value)),
  toggleCartMenu: value => dispatch(elementsActions.toggleCartMenu(value))
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Header));
